/**
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business ops UI のアクセント付きパネル（AI 事前調査ボックス・自動報告プレビュー・エスカレーション確認）。demo.html のグラデーション枠を PIL の semantic トークン（info / success / warning）で再現する
 * @graph-connects none
 */
import type { ReactNode } from 'react';

/** トーン → 枠/背景クラス。 @graph-connects none */
const BOX_TONE = {
  info: 'border-[var(--color-info)]/30 bg-[var(--color-info-muted)]',
  success: 'border-[var(--color-success)]/30 bg-[var(--color-success-muted)]',
  warning: 'border-[var(--color-warning)]/30 bg-[var(--color-warning-muted)]',
};

/** トーン → 見出し文字色クラス。 @graph-connects none */
const TITLE_TONE = {
  info: 'text-[var(--color-info)]',
  success: 'text-[var(--color-success)]',
  warning: 'text-[var(--color-warning)]',
};

/** AccentBox の props。 */
export interface AccentBoxProps {
  /** 見出し（先頭アイコン込みで渡す）。 */
  title: ReactNode;
  /** 本文。 */
  children: ReactNode;
  /** 配色トーン（info=AI, success=完了報告, warning=エスカレーション確認）。 */
  tone?: 'info' | 'success' | 'warning';
}

/** アクセント色で囲ったパネル。AI 事前調査 / 自動報告プレビューに使う。 @graph-connects none */
export function AccentBox({ title, children, tone = 'info' }: AccentBoxProps): ReactNode {
  return (
    <div className={`rounded-lg border p-4 ${BOX_TONE[tone]}`}>
      <div className={`mb-2 text-xs font-bold ${TITLE_TONE[tone]}`}>{title}</div>
      <div className="text-sm text-[var(--color-text-secondary)]">{children}</div>
    </div>
  );
}
